import React from "react";
import { useResponsiveStyles } from "../../../../styles/useResponsiveStyles";

export const MetricDisplay = ({ data }) => {
    const { getFontSize } = useResponsiveStyles();

    const roundNumber = (num) => {
        if (typeof num === 'number') {
            return Math.trunc(num);
        }
        const parsed = parseFloat(num);
        return isNaN(parsed) ? "-" : Math.trunc(parsed);
    };

    const metrics = [
        {
            value: roundNumber(data?.aum),
            label: "AUM (Cr)",
        },
        {
            value: roundNumber(data?.india_holding),
            label: "IN Holding",
        },
        {
            value: parseFloat(data?.client_volume) !== 0
                ? roundNumber(parseFloat(data?.ambit_volume) / parseFloat(data?.client_volume))
                : 0,
            label: "Market Share",
        },
        { value: roundNumber(data?.bps), label: "BPS" },
        {
            value: roundNumber(data?.client_volume),
            label: "Volume",
        },
    ];

    return (
        <div className="flex justify-evenly gap-2 bg-blue-50/50 rounded-lg border border-[#E3EEFF] w-4/5 items-center">
            {metrics.map((metric, index) => (
                <div key={index} className="flex flex-col">
                    <div className="flex items-end justify-center">
                        <div
                            className="font-bold text-red-500 "
                            style={getFontSize("stat")}
                        >
                            {metric?.value}
                        </div>
                    </div>
                    <div
                        className=" text-[#4C4E64] font-semibold text-center"
                        style={getFontSize("body1")}
                    >
                        {metric?.label}
                    </div>
                </div>
            ))}
        </div>
    );
};
